import { defineStore } from "pinia";
import { ref } from "vue";
import { useBase } from "@/utils/stores/base";

const storeName = "extractionSettings";

export const useExtractionSettingsStore = defineStore(storeName, () => {
  const { baseFetchAll, basePut } = useBase(storeName);

  const settings = ref(null);

  const fetch = async (errorCallback) => {
    settings.value = await baseFetchAll("extraction-settings", errorCallback);
    return settings.value;
  };

  // Fetch once per session: the extraction views only need the page counts, and they
  // change far less often than a user opens a new mandate.
  const ensureLoaded = async (errorCallback) => {
    if (settings.value) return settings.value;
    return await fetch(errorCallback);
  };

  const update = async (payload, callback, errorCallback) => {
    await basePut(
      "extraction-settings",
      payload,
      (data) => {
        settings.value = data;
        if (callback) callback(data);
      },
      errorCallback,
    );
  };

  const pagesFor = (documentType) => {
    const setting = settings.value?.documentSettings?.find((s) => s.documentType === documentType);
    if (!setting) return null;

    return { firstPages: setting.firstPages, lastPages: setting.lastPages };
  };

  return { settings, fetch, ensureLoaded, update, pagesFor };
});
